import script from "./person-list.vue?vue&type=script&setup=true&lang=js"
export * from "./person-list.vue?vue&type=script&setup=true&lang=js"

import "./person-list.vue?vue&type=style&index=0&id=29087b91&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29087b91"]])

export default __exports__